var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfowindowMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.32901C2.5 10.8829 2.5 14.8687 2.5 14.8687C2.5 15.862 3.33947 16.6673 4.375 16.6673H15.625C16.6605 16.6673 17.5 15.862 17.5 14.8687V7.90687M2.5 8.32901C2.5 8.01893 2.66652 7.73073 2.94063 7.56639L10 3.33398L17.0221 7.12305C17.3173 7.28233 17.5 7.58197 17.5 7.90687M2.5 8.32901C2.875 8.32901 10 12.7768 10 12.7768L17.5 7.90687",
    stroke: "#3BAFDA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfowindowMail);
export default __webpack_public_path__ + "static/media/infowindow-mail.e068c229e772672401a5056428b05753.svg";
export { ForwardRef as ReactComponent };